import React from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { useModal } from 'store/modals';
import { useIntl } from 'react-intl';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import { discardChanges } from '../../../../discardChanges';
import styles from './styles.module.scss';

export function AccessRule({ accessRule }) {

  const accessManagement2NModal = useAccessManagement2NModal();
  const accessRuleId = accessRule && (accessRule.Id || accessRule.id);
  const selectedAccessRuleId = accessManagement2NModal.selected.accessRule && accessManagement2NModal.selected.accessRule.Id;
  const accessRuleName = (accessRule && accessRule.Name) || '';
  const modal = useModal();
  const intl = useIntl();

  const onAccessRuleClick = () => discardChanges('accessRule', accessRule, intl, accessManagement2NModal, modal);

  return (
    <div
      className={styles.accessRuleCard}
      onClick={onAccessRuleClick}
    >
      <div className={styles.details}>
        <Text
          size={14}
          uppercase
        >
          {accessRuleName}
        </Text>
      </div>

      <ShouldRender condition={!!accessManagement2NModal.selected.accessRule && selectedAccessRuleId === accessRuleId}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
}

